import { ContentTypes } from '@/client/services/api/graphql/gql/graphql';
import { useTranslation } from 'react-i18next';

// TODO: Change these translation keys to global.contentTypes.*
// TODO: Replace all instances of contentTypeMap to get a human readable content type with this hook.

export const useGetHumanReadableContentType = () => {
  const { t } = useTranslation();

  const contentTypeMap: { [key: ContentTypes | string]: string } = {
    [ContentTypes.Article]: t('contentSearch.article'),
    article: t('contentSearch.article'),
    [ContentTypes.File]: t('contentSearch.media'),
    file: t('contentSearch.media'),
    [ContentTypes.Video]: t('contentSearch.media'),
    video: t('contentSearch.media'),
    [ContentTypes.Scorm]: t('contentSearch.scorm'),
    scorm: t('contentSearch.scorm'),
    [ContentTypes.Assessment]: t('contentSearch.assessment'),
    assessment: t('contentSearch.assessment'),
    [ContentTypes.Track]: t('contentSearch.track'),
    track: t('contentSearch.track'),
    [ContentTypes.Journey]: t('contentSearch.journey'),
    journey: t('contentSearch.journey'),
    [ContentTypes.ImportedContent]: t('contentSearch.imported_content'),
    imported_content: t('contentSearch.imported_content'),
    [ContentTypes.Workshop]: t('contentSearch.workshop'),
    workshop: t('contentSearch.workshop'),
    [ContentTypes.MultiSessionWorkshop]: t('contentSearch.multiSessionWorkshop'),
    multi_session_workshop: t('contentSearch.multiSessionWorkshop'),
    [ContentTypes.MultiSessionWorkshopSession]: t('contentSearch.multiSessionWorkshopSession'),
    multi_session_workshop_session: t('contentSearch.multiSessionWorkshopSession'),
    [ContentTypes.Poll]: t('contentSearch.poll'),
    poll: t('contentSearch.poll'),
    [ContentTypes.Presentation]: t('contentSearch.presentation'),
    presentation: t('contentSearch.presentation'),
  };

  const getHumanReadableContentType = (contentType: ContentTypes | string) =>
    contentTypeMap[contentType];

  return {
    contentTypeMap,
    getHumanReadableContentType,
  };
};
